import { Navigate, Outlet, useLocation } from "react-router";
import { useAuth } from "../contexts/authContext";

function ProtectedRoute({ requireUserType = false, allowedUserTypes = [] }) {
  const { user, loggingOutRef } = useAuth();
  const location = useLocation();

  // If user is not authenticated, redirect to login
  if (!user) {
    if (loggingOutRef.current) {
      loggingOutRef.current = false;
      return <Navigate to="/" replace />;
    }
    return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname)}`} />;
  }

  // If user is not profile complete, only allow complete-profile routes
  if (!user.is_profile_complete) {
    const isProfileCompletionRoute = location.pathname.startsWith("/complete-profile");
    return isProfileCompletionRoute ? (
      <Outlet />
    ) : (
      <Navigate to="/complete-profile/role-selection" replace />
    );
  }

  // Admins bypass all user_type restrictions
  if (user?.is_admin) {
    return <Outlet />;
  }

  // Require user_type for guarded route groups like lecturer/student dashboards.
  if (requireUserType && !user?.user_type) {
    return <Navigate to="/complete-profile/role-selection" replace />;
  }

  // Restrict route access to specific user types when configured.
  if (
    allowedUserTypes.length > 0 &&
    user?.user_type &&
    !allowedUserTypes.includes(user.user_type)
  ) {
    return <Navigate to={`/${user.user_type}/dashboard`} replace />;
  }

  // If user is authenticated and profile is complete, render the protected route
  return <Outlet />;
}

export default ProtectedRoute;
